import React, { useEffect, useState } from 'react';
import SparkIcon from './SparkIcon';
import './Layout.css';

const agreeToCookiesKey = 'agreed-to-cookies';

const CookieBanner = () => {
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    const cookieAccepted = document.cookie.split(';').some((cookie) => cookie.trim() === `${agreeToCookiesKey}=true`);
    setShowCookieBanner(!cookieAccepted);
  }, []);

  const acceptCookies = () => {
    document.cookie = `${agreeToCookiesKey}=true; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;
    setShowCookieBanner(false);
  };

  if (!showCookieBanner) {
    return null;
  }

  return (
    <aside
      aria-label="Использование cookie"
      className="cookie-banner"
    >
      <div className="cookie-message">
        <SparkIcon className="cookie-symbol" />
        <p>
          Используем cookie, чтобы сайт работал лучше.
          {' '}
          <a href="/privacy-policy">Подробнее в политике</a>
        </p>
      </div>
      <button
        className="cookie-accept"
        onClick={acceptCookies}
        type="button"
      >
        Хорошо
      </button>
    </aside>
  );
};

export default CookieBanner;
